module.exports = __webpack_public_path__ + "img/05.3b1093c5.png";